export enum PartnerStatus {
  free = 'free',
  basic = 'basic',
  gold = 'gold',
  platinum = 'platinum',
}

export type TimeRange = string[];
export type DateRange = [Date, Date];
export type OpeningHours = TimeRange[];
export interface OpeningTimeInfo {
  isOpenNow: boolean;
  nextOpenDayTime: Date;
}

export interface Timing {
  day: string;
  opensAt: string;
  closesAt: string;
}

export interface TimingList {
  data: Timing[];
  unit: string;
}

export interface PartnerDescription {
  city: string;
  houseNumber: string;
  merchantPartnerName: string;
  objectID: string;
  street: string;
  url: string;
  zip: string;
  _geoloc: {
    lat: string;
    lng: string;
  };
  merchantLogo: string;
  openingHours: TimeRange[];
  showMerchantAd: boolean;
  merchantPartnerStatus: PartnerStatus;
}

export interface LocalDealerData extends PartnerDescription {
  merchantImages: string;
  merchantInfo: string;
  partnerUrl?: string;
  phoneNumber?: string;
  backgroundImage?: string;
  merchantPartnerID: string;
  merchantPartnerStoreID?: string | number;
}
